import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';

export interface IContentBarButtons {
	image?: IImage;
	link?: ILink;
}

export interface IContentBarProps extends IBaseElementProps {
	image?: IImage;
	subheading?: string;
	heading?: string;
	text?: string;
	button?: IContentBarButtons;
	tagline?: string;
	style?:
	| 'default'
	| 'secondary'
	| 'neutral';
}

/**
 * Content Bar
 * @block
 * @requiresHooks
 * @icon editor-insertmore
 */

const ContentBar: React.FC<IContentBarProps> = ({
	className,
	classNames = [],
	image,
	subheading,
	heading,
	text,
	button,
	tagline,
	style = 'default',
}) => (
	<div
		className={
			className || cn('content-bar', `content-bar--${style}`, ...classNames)
		}
	>
		<div className="content-bar__title">
			<div className="content-bar__container content-bar__container--title">
			<div className="content-bar__wrapper">
					{subheading && <p className="content-bar__subheading">{subheading}</p>}
					{heading && <h2 className="content-bar__heading">{heading}</h2>}
						{button && (
							<div className="content-bar__cta">
								<a
									className="btn btn-primary btn-lg content-bar__button"
									href={button.link.href}
								>
									{button.image && <Image {...button.image} />}
									{button.link.label}
								</a>
								{tagline && <p className="content-bar__tagline">{tagline}</p>}
							</div>
						)}
				</div>
			</div>
		</div>
		<div className="content-bar__text">
			<div className="content-bar__container  content-bar__container--text">
					{image && (
						<div className="content-bar__image-wrapper">
							<Image
								{...image}
							/>
						</div>
					)}
					<div className="content-bar__wrapper">
						{text && <div className="content-bar__text">{text}</div>}
					</div>
			</div>
		</div>
	</div>
);

export default ContentBar;
